<template>
  <v-chip v-if="label" x-small label color="teal lighten-5" text-color="teal darken-3" class="cedido-label">
    <v-icon x-small left>mdi-car-key</v-icon>
    {{ label }}
  </v-chip>
</template>

<script>
// ME-01 / F-06: etiqueta de vehículo cedido por movimiento excepcional.
//  - Propietario: «Cedido a X» (X = dealer que lo tiene).
//  - Dealer que lo tiene y sus partners: «Cedido por X» (X = propietario).
// Con `vehicle`, la etiqueta refleja el estado ACTUAL del vehículo (uso en
// VEHÍCULOS). Con `movement`, se usa el `cedido_meta` histórico del
// movimiento, que se congela en el instante en que se creó la operación: así
// la etiqueta se mantiene en MOVIMIENTOS/CESIONES/COMODATOS aunque el
// vehículo haya vuelto después.
export default {
  name: 'CedidoLabel',
  props: {
    vehicle: { type: Object, default: null },
    movement: { type: Object, default: null }
  },
  computed: {
    label () {
      const meta = (this.movement && this.movement.cedido_meta)
        || (this.vehicle && this.vehicle.cedido_meta)
      if (!meta || !meta.is_cedido || !meta.owner || !meta.holder) return null
      const user = this.$store.getters.CURRENT_USER
      const myDealerId = user && user.dealer ? user.dealer.id : null
      if (myDealerId && Number(myDealerId) === Number(meta.owner.id)) {
        return `Cedido a ${meta.holder.name}`
      }
      return `Cedido por ${meta.owner.name}`
    }
  }
}
</script>
